let yearOptions = [
  {
    value: "",
    displayValue: "Année",
  },
];
const currentYear = new Date().getFullYear();
for (var year = currentYear - 1; year > currentYear - 5; year--) {
  yearOptions.push({
    value: year,
    displayValue: year,
  });
}

const sirenOptions = [
  { value: "true", displayValue: "Oui" },
  { value: "false", displayValue: "Non" },
];

export { yearOptions, sirenOptions };
